import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=0eef9d34&scoped=true&"
import script from "./carousel.vue?vue&type=script&lang=ts&"
export * from "./carousel.vue?vue&type=script&lang=ts&"
import style0 from "./carousel.vue?vue&type=style&index=0&id=0eef9d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eef9d34",
  null
  
)

export default component.exports